'use client'

import { Stack } from '@mui/system'

import RequestDemoForm from '@/components/RequestDemoForm'
import HomepageLogos from '@/sections/HomepageLogos'

export default function Page() {
    return (
        <Stack
            pt={{
                xs: 0,
                sm: 0,
                md: 9,
                lg: 9,
                xl: 9,
            }}
            pb={{
                xs: 6,
                md: 11,
            }}
            spacing={{
                xs: 10,
                md: 15,
            }}
        >
            <RequestDemoForm hubspotFormId={'a52064a2-03a4-4108-a386-6e5f28b93e8c'} />
            <HomepageLogos removeBorder={true} />
        </Stack>
    )
}
